import { mountVueComponent } from '@/lib/mount-vue-component';

export default () => {
  import('@/modules/payment-methods/components/PaymentMethodsList.vue').then(PaymentMethodsList => {
    mountVueComponent('payment-methods-list', PaymentMethodsList);
  });
};
